import "suggestions-jquery/dist/js/jquery.suggestions.min";
import { DADATA_API_KEY } from "../lib/constants";

const contactWithUsField = () => {
  const cityField = $("#city")
    .suggestions({
      serviceUrl: "https://dadata.ru/api/v2",
      token: DADATA_API_KEY,
      type: "ADDRESS",
      count: 5,
    })
    .suggestions();
};

export const dadataFunctions = () => {
  contactWithUsField();
};
